module.exports = __webpack_public_path__ + "img/first-app-subtitle.b18ad387.png";